import { IActions, Context } from './actions.types';
import { AppConstants } from '@/shared/app.constants';
import { Notification, INotification } from '@/entities'

const formatedTimestamp = () => {
    const d = new Date()
    const date = d.toISOString().split('T')[0];
    const time = d.toTimeString().split(' ')[0];
    return `${date} ${time}`
}

export const actions: IActions = {

    /** set the selected application  */
    setApplicationId(context: Context, id: number) {
        if (id) {
            context.commit('setSelectedApplication', id);
        }
    },

    /** set the selected review */
    setReviewId(context: Context, id: number) {
        if (id) {
            context.commit('setSelectedReview', id);
        }
    },

    /*** Get review data */
    getData(context: Context, payload: any) {
        if (payload) {
            return this.$services.review.getReviewData(payload)
                .then((data: any) => {
                    if (data != null) {
                        context.commit('setPrefilledData', data.review);
                    }

                    return data;
                });
        }
    },

    /** Get review categories */
    getCategories(context: Context, payload: any) {
        let lang: string = localStorage.getItem("language") || 'en-US';

        if (payload) {
            return this.$services.review.getCategories(payload.id, lang, payload.entity)
                .then((data: any) => {
                    return data;
                });
        }
    },
    /** Get the template */
    getTemplate(context: Context, id: number) {
        if (id) {
            this.$services.review.getReviewTemplate(id)
                .then((data: any) => {
                    context.commit('setTemplate', data);
                    context.commit('refreshTemplates');
                });
        }
    },
    /** create new review */
    create(context: Context, payload: any) {
        return this.$services.review.saveReviewData(payload)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    // context.commit('setNotification', {text: 'Saved successfully', color: 'success'});
                    return data.Record;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, isHtml: true, color: 'error' } as INotification), { root: true });
                    return {};
                }
            });
    },

    /** create new review */
    submit(context: Context, payload: any) {
        return this.$services.review.submitReviewData(payload.entity, payload.id, payload.data)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    // context.commit('setNotification', {text: 'Saved successfully', color: 'success'});
                    return data.Record;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, isHtml: true, color: 'error' } as INotification), { root: true });
                }
            });
    },

    /** update the state while switch the language */
    updateLanguage(context: Context, payload: string): void {
        context.commit('setLanguage', payload);
        context.commit('refreshTemplates');
    },

    /** save the review form data */
    saveReviewData(context: Context, payload: any): any {
        if (payload.id) {
            return this.$services.review.updateReviewData(payload.entity, payload.id, payload.data)
                .then((data: any) => {
                    if (data.Result === 'OK') {
                        context.commit('setReview', data.Record);
                        context.commit('application/setNotification', new Notification({ snack: true, text: 'Saved successfully', color: 'success' } as INotification), { root: true });
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, color: 'error' } as INotification), { root: true });
                    }
                });
        }
    },
    createReview(context: Context, payload: any): any {
        const form = {
            reviews: payload.reviews || [],
            override: payload.override || false,
            comment: payload.comment,
            totalScore: payload.totalScore,
            recommendation: payload.recommendation,
            applicationId: payload.applicationId,
            reviewerId: payload.reviewerId,
            version: payload.version,
            status: AppConstants.reviewStatus.In_Progress,
            auditInfo: {
                createdDate: formatedTimestamp()
            }
        };
        return this.$services.review.saveReviewData(form)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    context.commit('setReview', data.Record);
                } else {
                    console.log(data);
                }
            });
    },
    disagreeReviewCoi(context: Context, payload: any): any {
        return this.$services.review.disAgreeCOI(payload)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    return data.Record;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, isHtml: true, color: 'error' } as INotification), { root: true });
                }
            });
    }
}